import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormRates } from './FormRates';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeleteRates } from './DeleteRates';
import { Dialog } from 'primereact/dialog';


export const ModalRates = (props) => {

    const {
        branches, commercialLines, typeRate, modal, toggle, modalTitle, method, loading,
        handleInputChange, handleSelectValues, validacionesRates,
        name, abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate,
        saveCreate, saveUpdate, saveDelete, changeCheckbox, isMultiSelectOpen,
        toggleDivCommercialLine, branchDefault, selectedBranch,
        viewDivBranches, hasDefaultRate,
        isDelete, valueCode, setValueCode, confirmationUpdate, validCode

    } = props;

    return (
        <Dialog
            className="pt-0 medium-dialog0"
            header={modalTitle}
            visible={modal}
            modal
            onHide={toggle}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}

        >
            {
                method === "create"
                    ? <FormRates button={ModalButtonSave}
                        {...{ branches, commercialLines, typeRate, toggle, loading, handleInputChange, validacionesRates, methodAction: saveCreate, name, abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate, toggleDivCommercialLine, viewDivBranches, branchDefault, changeCheckbox, isMultiSelectOpen, selectedBranch, hasDefaultRate }}
                    />
                    : (method === "update")
                        ? <FormRates button={ModalButtonUpdate}
                            {...{
                                branches, commercialLines, typeRate, toggle, loading, handleInputChange, validacionesRates, methodAction: saveUpdate, name, abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate, toggleDivCommercialLine, viewDivBranches, branchDefault, changeCheckbox, isMultiSelectOpen, selectedBranch, hasDefaultRate,
                                isDelete, valueCode, setValueCode, confirmationUpdate, validCode

                            }}
                        />
                        : <DeleteRates {...{ toggle, loading, name, abbreviation, saveDelete }} />
            }

        </Dialog>

    )
}
